import { handleWindow } from './common';

// 类型定义
export type ServerRequest = {
  headers?: {
    'user-agent'?: string;
  };
};

/**
 * 获取服务端环境下的用户代理字符串
 */
function getServerUserAgent(req: ServerRequest): string {
  return req?.headers?.['user-agent'] || '';
}

/**
 * 获取客户端环境下的用户代理字符串
 */
function getClientUserAgent(): string {
  return handleWindow().navigator.userAgent;
}

/**
 * 获取用户代理字符串
 * @param {ServerRequest} [req] - 服务端请求对象
 * @returns {string} - 用户代理字符串
 */
export function getUserAgent(req?: ServerRequest): string {
  return req ? getServerUserAgent(req) : getClientUserAgent();
}
